/**
 * Shared auth constants
 */

export const GUEST_EMAIL_SUFFIX = "@guest.local";
export const GUEST_STORAGE_KEY = "cloudnest_guest_id";
export const GUEST_NICKNAME_STORAGE_KEY = "cloudnest_guest_nickname";
export const GUEST_SHARE_STORAGE_PREFIX = "cloudnest_guest_share_v1";
export const USER_STORAGE_KEY = "cloudnest_user";
export const CSRF_COOKIE_NAME = "csrf_token";
export const CSRF_HEADER_NAME = "X-CSRF-Token";
